export enum ScraScanStatus {
  UNSUBMITTED = 'Unsubmitted',
  UNSUBMITTED_LIMIT_REACHED = 'Unsubmitted Limit Reached',
  BATCH_PENDING = 'Batch Pending',
  PENDING = 'Pending',
  /** Single-record check waiting on an SCRA outage (EE-460). Resubmitted when SCRA is back. */
  PENDING_PROVIDER = 'Pending Provider',
  COMPLETED = 'Completed',
  DATA_ERROR = 'Data Error',
  INVALID_DATA = 'Invalid Data'
}
